// extracted by mini-css-extract-plugin
export var animationContainer = "_jr-0";
export var footer = "_jr-1";
export var gray = "_jr-2";
export var lineItem = "_jr-3";
export var lineItemImage = "_jr-4";
export var lineItemInfo = "_jr-5";
export var lineItemText = "_jr-6";
export var lineItems = "_jr-7";
export var modalContent = "_jr-8";
export var options = "_jr-9";
export var orderName = "_jr-a";
export var refundAmount = "_jr-b";